import Vue from 'vue';
import VueRouter from 'vue-router';

import LandingPage from "@/views/LandingPage";
import FoodFest from "@/views/FoodFest";
import Shop from "@/views/ShopPage";
// import ApplyFoodFest from "@/views/ApplyFoodFest";
import About from "@/views/About";
import SupportUs from "@/views/SupportUs";
import Login from "@/views/Login";
import Blog from "@/views/Blog";
import BlogPost from "@/views/BlogPost";

Vue.use(VueRouter);

const routes = [
    { path: '*', redirect: '/' },
    {
        path: '/',
        component: LandingPage
    },
    {
        path: '/zinas',
        component: Blog
    },
    {
        path: '/zinas/:id',
        component: BlogPost
    },
    {
        path: '/svetki',
        component: FoodFest
    },
    {
        path: '/veikals',
        component: Shop
    },
    // {
    //     path: '/pieteikties',
    //     component: ApplyFoodFest
    // },
    {
        path: '/parmums',
        component: About
    },
    {
        path: '/atbalstit',
        component: SupportUs
    },
    {
        path: '/pieslegties',
        component: Login
    }
];

export default {
    name: "Router",
    data: new VueRouter({
        mode: 'history',
        routes,
        scrollBehavior (to, from, savedPosition) {
            if (savedPosition) {
                return savedPosition
            } else {
                return { x: 0, y: 0 }
            }
        }
    })
}